import { Link, createFileRoute } from "@tanstack/react-router"

import unicornLogo from "../assets/favicon.svg"
type ManualParagraph =
  | string
  | {
      before: string
      linkText: "Guild War Manual"
      after: string
    }

type ManualEvent = {
  title: string
  paragraphs: readonly ManualParagraph[]
  rewards?: readonly string[]
}

type ManualEventSection = {
  id: string
  events: readonly ManualEvent[]
}

const contents = [
  ["what-are-activity-points", "What are Activity Points?", 0],
  ["activity-points", "What are Activity Points?", 1],
  ["why-activity-points", "Why do I need to get Activity Points?", 1],
  ["estimated-activity-points", "Estimated Activity Points per Event", 1],
  ["guild-events", "How to do Guild Events?", 0],
  ["consume-energy-guild-hero-realm", "Consume Energy, Guild’s Hero Realm", 1],
  ["carefree-moments-arena", "Carefree Moments, Participate in Arena", 1],
  ["guild-transporter-party", "Guild Transporter, Guild Party", 1],
  [
    "test-your-skills-path-to-riches",
    "Test Your Skills (Showdown), Path to Riches",
    1,
  ],
  ["breaking-army", "Breaking Army", 1],
  [
    "co-op-exploration-two-player-pose",
    "Co-op Exploration, Two-player Pose",
    1,
  ],
  [
    "wandering-paths-skyward-bond",
    "Wandering Paths - Leisure mode, Skyward Bond",
    1,
  ],
  ["guild-war-custom-events", "Guild War, Custom Events", 1],
] as const

const activityPointRows = [
  ["Consume Energy", "This week consume 200 energy", "380"],
  ["Guild Hero's Realm", "Clear Guild Hero's Realm once this week", "125"],
  ["Carefree Moments", "This week stay in base 20 minutes", "380"],
  ["Participate in Arena", "Participate in Arena 10 this week (5/5)", "325"],
  [
    "Guild Transporter",
    "Participate in cargo delivery 3 times this week",
    "690",
  ],
  ["Guild Party", "Participate in the Party for 25 min this week", "720"],
  ["Test Your Skills", "Participate in Showdown 2 times this week", "400"],
  ["Path to Riches", "Earn 2000 commerce coins this week", "260"],
  ["Co-op Exploration", "This week Co-op Exploration 20 minutes", "325"],
  ["Breaking Army", "Participate in Breaking Army 2 times this week", "540"],
  ["Two-player Pose", "This week duo emotes in Guild base 20 times", "260"],
  [
    "Leisure in Wandering",
    "Participate in Wandering Paths - Leisure Gameplay 10 times this week (5/5)",
    "260",
  ],
  ["Skyward Bond", "Participate in Skyward Bond", "400"],
  ["Guild War", "Participate in the Guild War", "500"],
] as const

const eventSections: readonly ManualEventSection[] = [
  {
    id: "consume-energy-guild-hero-realm",
    events: [
      {
        title: "Consume Energy",
        paragraphs: [
          "Use 200 energy from Menu -> Wandering Paths -> Challenges, any event from there (Campaign Challenge, Outposts, Hero's Realm, Sword Trial). It counts after taking the rewards after completing.",
        ],
        rewards: [
          "Rewards : 80 x Wonder Jade, 80 x Treasure Token, 5 x Guild Reputation.",
        ],
      },
      {
        title: "Guild’s Hero Realm",
        paragraphs: [
          "Guild Hero's Realm is the PvE guild activity where only guild members can join and is required 10 people to join, optionally we can take 3 people outside the Guild, but they need to be Sworn Cohort/Partner/Master/Disciple with at least one person in the team.",
          "This raid is done multiple days per week (usually when you see the GHR invite in the game chat of the guild or the GHR event in ┃📅・guild-events on Discord).",
        ],
        rewards: [
          "Rewards : Supreme: 10 x Tier X Gear Chests, 2 x Attune Stones, 40 x Adventure Slip, 21000 x Coin, EXP.",
        ],
      },
    ],
  },
  {
    id: "carefree-moments-arena",
    events: [
      {
        title: "Carefree Moments",
        paragraphs: [
          "For this activity you have to stay 20 minutes per week in Guild Area (Menu -> Guild -> Return to base).",
        ],
        rewards: [
          "Rewards : 80 x Wonder Jade, 80 x Treasure Token, 5 x Guild Reputation, 4201 x Coin, 3860 x EXP.",
        ],
      },
      {
        title: "Participate in Arena",
        paragraphs: [
          "This event needs your implication in PVP matches (Menu - Wandering Path - Arena). 10 matches are required for the full rewards.",
        ],
        rewards: [
          "Rewards : 50 x Wonder Jade, 50 x Treasure Token, 5 x Guild Reputation.",
        ],
      },
    ],
  },
  {
    id: "guild-transporter-party",
    events: [
      {
        title: "Guild Transporter",
        paragraphs: [
          "For this event you have to donate items at Wen Wushuang <Guild Transporter> (find him by going straight from the guild base spawn). You can gather the items from the world, by buying them from the NPC or you can request up to 5 items from guild members.",
        ],
        rewards: [
          "Rewards : 120 x Wonder Jade, 120 x Treasure Token, 10 x Guild Reputation, 10471 x Coin, 9650 x EXP.",
        ],
      },
      {
        title: "Guild Party",
        paragraphs: [
          "This event is scheduled everyday and to participate you have to click on Menu -> Guild -> Event -> Guild Party -> Go or just by simply walking to the guild base pool. You need to gather a total of 25 minutes by going there in more days.",
        ],
        rewards: ["Rewards : 180 x Wonder Jade, 180 x Treasure Token."],
      },
    ],
  },
  {
    id: "test-your-skills-path-to-riches",
    events: [
      {
        title: "Showdown",
        paragraphs: [
          "This event can be completed by joining/spectating the PVP in guild area and it is scheduled two days per the week (Thursday and Sunday). Go using Menu -> Guild -> Event -> Showdown -> Go.",
          "After you reach the guild arena, you can register/spectate. For the full reward is required to participate any of the day.",
        ],
        rewards: [
          "Rewards (once) : 160 x Wonder Jade, 160 x Treasure Token, 20 x Guild Reputation, 6270 x Coin, 5790 x EXP.",
        ],
      },
      {
        title: "Path to Riches",
        paragraphs: [
          'The easiest way to finish this event is by buying the bag of 2500 Commerce Coins from the shop. (Shop -> Offers -> Season Shop -> Combat Development -> Buy and open "Small Box of Commerce Coins".',
        ],
        rewards: [
          "Rewards : 55 x Wonder Jade, 55 x Treasure Token, 5 x Guild Reputation, 2947 x Coin, 2705 x EXP.",
        ],
      },
    ],
  },
  {
    id: "breaking-army",
    events: [
      {
        title: "Breaking Army",
        paragraphs: [
          "This PvE event is happening two times per week (Wednesday and Saturday) and there will be a boss fight where you have to register to fight/spectate to participate.",
          "To go there you have to use Menu -> Guild -> Event -> Showdown -> Go. The event will be completed if you participate on both days.",
          "Participating more times in the same day doesn't give you more rewards. If you already did once and you don’t feel that you could hit Leaderboard, please let other people who feel that they can do it. No matter how many times you kill the boss, it will count as one for Guild Events.",
          "The Boss is changed every Breaking Army, to check which one is gonna be next, please check #guild-announcements on Discord.",
        ],
        rewards: [
          "Rewards (once) : 55 x Wonder Jade, 55 x Treasure Token, 20 x Guild Reputation, 4389 x Coin, 4055 x EXP.",
        ],
      },
    ],
  },
  {
    id: "co-op-exploration-two-player-pose",
    events: [
      {
        title: "Co-op Exploration",
        paragraphs: [
          "Join Co-Op with any player for a total of 20 minutes (You can stay afk for that amount of time).",
        ],
        rewards: [
          "Rewards : 55 x Wonder Jade, 55 x Treasure Token, 5 x Guild Reputation, 2947 x Coin, 2705 x EXP.",
        ],
      },
      {
        title: "Two-player Pose",
        paragraphs: [
          "You have to dual-pose with other players, this is usually done at the Guild Party when we gather more players, but you can do it even with non-guild members. (There's a trick by spamming join pose button with others when they are using the Dual Cultivation on a higher heights, so you can skip the animations).",
        ],
        rewards: [
          "Rewards : 55 x Wonder Jade, 55 x Treasure Token, 5 x Guild Reputation.",
        ],
      },
    ],
  },
  {
    id: "wandering-paths-skyward-bond",
    events: [
      {
        title: "Participate in any Wandering Paths - Leisure mode",
        paragraphs: [
          "Can be done with multiplayer emotes like Dual Pose, from emotes menu or by participating in Leisure games like Pitch Pot.",
          "Shortcut: Use Eternal Vow with second player and wait for 10 *tics* of rewards on the left side, then it’s done.",
        ],
        rewards: [
          "Rewards: 55 x Wonder Jade, 55 x Treasure Token, 5 x Guild Reputation.",
        ],
      },
      {
        title: "Participate in Skyward Bond",
        paragraphs: [
          "Scheduled on Friday for everyone to complete Floor 1 to get this event to be done.",
          "For higher Floors it requires high DPS players to kill the bosses within amount of time.",
        ],
        rewards: [
          "Rewards are depended on the completed floor and they are shared with all members in the Guild.",
        ],
      },
    ],
  },
  {
    id: "guild-war-custom-events",
    events: [
      {
        title: "Guild War",
        paragraphs: [
          "It’s PvP Event Guild vs Guild where can take up to 30 players.",
          {
            before: "Signing up and more information you can find on ",
            linkText: "Guild War Manual",
            after: ".",
          },
        ],
        rewards: [
          "Rewards are depended on rank, win/lose, etc.: Echo Jades, Guild Reputation, Wonder Jades.",
        ],
      },
      {
        title: "Custom Events",
        paragraphs: [
          "You can create your own Event, from GHR through any Leisure activity and dungeons to creating the event with your own idea. You can set the date and the time. All members will see it on Guild Chat and also in Custom Events tab.",
          "There is NO rewards.",
        ],
      },
    ],
  },
]

export const Route = createFileRoute("/activity-points-manual")({
  component: ActivityPointsManualRoute,
})

function ActivityPointsManualRoute() {
  return (
    <main id="main-content" className="activity-manual min-h-screen">
      <section className="activity-manual-hero">
        <div className="activity-manual-hero-inner mx-auto max-w-7xl px-4 md:px-8 lg:px-10">
          <Link
            to="/"
            aria-label="Unicornis home"
            className="activity-manual-hero-logo"
          >
            <img src={unicornLogo} alt="" />
          </Link>
          <h1 className="text-balance">Activity Points Manual</h1>
          <p>V1.0 || 25/07/2026</p>
        </div>
      </section>

      <div className="activity-manual-shell mx-auto max-w-7xl px-4 py-8 md:px-8 md:py-10 lg:px-10">
        <details className="activity-manual-toc-mobile">
          <summary>Table of Content</summary>
          <ManualToc showTitle={false} />
        </details>
        <aside className="activity-manual-toc-desktop">
          <ManualToc />
        </aside>
        <article className="activity-manual-document">
          <section
            id="what-are-activity-points"
            className="activity-manual-section scroll-mt-6"
            tabIndex={-1}
          >
            <div className="activity-manual-section-heading">
              <h2>What are Activity Points?</h2>
            </div>
            <div className="activity-manual-overview-grid">
              <section
                id="activity-points"
                className="activity-manual-panel scroll-mt-6"
                tabIndex={-1}
              >
                <h3>What are Activity Points?</h3>
                <p>
                  Activity Points are points which you can gain by doing Guild
                  Events.
                </p>
                <p>More Guild Events done, more Activity Points you get.</p>
                <p>
                  You can see your Activity Points in the Member Roster View
                  tab.
                </p>
              </section>
              <section
                id="why-activity-points"
                className="activity-manual-panel scroll-mt-6"
                tabIndex={-1}
              >
                <h3>Why do I need to get Activity Points?</h3>
                <ul>
                  <li>
                    Activity Points are important for the Guild Prosperity which
                    is taken as one of factors for Guild War Ranking, Breaking
                    Army Leaderboard or Prosperity Ranking.
                  </li>
                  <li>
                    By gaining Activity Points we also get Guild Fund which is
                    necessary for Guild to exist.
                  </li>
                  <li>
                    We get Activity Rewards which is the total activity of all
                    members. Reaching these activity milestones grants valuable
                    progression currencies like Mirage Sachets (used to upgrade
                    stats in Techniques) and Treasure Tokens (used to spend in
                    Guild Shop.
                  </li>
                  <li>
                    By doing Guild Events you also get Wonder Jade (for
                    Techniques), Treasure Tokens, Guild Reputation, Coins,
                    Character EXP and optionally Guild Newbie Gift.
                  </li>
                </ul>
              </section>
            </div>
            <section
              id="estimated-activity-points"
              className="activity-manual-panel scroll-mt-6"
              tabIndex={-1}
            >
              <h3>Estimated Activity Points per Event</h3>
              <div className="activity-manual-table" tabIndex={0}>
                <table>
                  <caption className="sr-only">
                    Estimated Activity Points per Event
                  </caption>
                  <thead>
                    <tr>
                      <th scope="col">Activity</th>
                      <th scope="col">Description</th>
                      <th scope="col">Points</th>
                    </tr>
                  </thead>
                  <tbody>
                    {activityPointRows.map(
                      ([activity, description, points]) => (
                        <tr key={activity}>
                          <th scope="row">{activity}</th>
                          <td>{description}</td>
                          <td>{points}</td>
                        </tr>
                      ),
                    )}
                  </tbody>
                  <tfoot className="activity-manual-total">
                    <tr>
                      <td colSpan={2} />
                      <td>6065</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </section>
          </section>

          <section
            id="guild-events"
            className="activity-manual-section scroll-mt-6"
            tabIndex={-1}
          >
            <div className="activity-manual-section-heading">
              <h2>How to do Guild Events?</h2>
            </div>
            {eventSections.map((section) => (
              <section
                key={section.id}
                id={section.id}
                className="activity-manual-event-section scroll-mt-6"
                tabIndex={-1}
              >
                <div className="activity-manual-event-grid">
                  {section.events.map((event) => (
                    <EventCard key={event.title} event={event} />
                  ))}
                </div>
              </section>
            ))}
          </section>
        </article>
      </div>
    </main>
  )
}

function ManualToc({ showTitle = true }: { showTitle?: boolean }) {
  return (
    <nav
      className="activity-manual-toc"
      aria-label="Activity Points Manual table of contents"
    >
      {showTitle ? <p>Table of Content</p> : null}
      <ol>
        {contents.map(([id, label, depth]) => (
          <li key={id} className={depth === 1 ? "pl-4" : undefined}>
            <Link
              to="/activity-points-manual"
              hash={id}
              className="focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
            >
              {label}
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  )
}

function EventCard({ event }: { event: ManualEvent }) {
  return (
    <section className="activity-manual-event">
      <h4 className="activity-manual-event-heading">{event.title}</h4>
      {event.paragraphs.map((paragraph, index) => (
        <p
          key={`${event.title}-${index}`}
          className={index === 0 ? undefined : "mt-3"}
        >
          {typeof paragraph === "string" ? (
            paragraph
          ) : (
            <>
              {paragraph.before}
              <Link
                to="/guild-war-guide"
                className="underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
              >
                {paragraph.linkText}
              </Link>
              {paragraph.after}
            </>
          )}
        </p>
      ))}
      {event.rewards ? (
        <ul className="activity-manual-rewards mt-4">
          {event.rewards.map((reward) => (
            <li key={reward}>{reward}</li>
          ))}
        </ul>
      ) : null}
    </section>
  )
}
